import { GoogleSocialAuthButton, PrivateRoute } from "./containers";

import {
  authenticationReducer,
  socialAuthenticateAccount,
  authenticateAccount,
  logoutAccount,
  registrationReducer,
  registerAccount,
  activationReducer,
  activateAccount,
  resendActivationEmail,
  passwordReducer,
  changePassword,
  sendResetPasswordEmail,
} from "./modules";

import {
  AccountActivationPage,
  ChangePasswordPage,
  LoginPage,
  RegisterPage,
  ResendActivationPage,
  ResetPasswordPage,
} from "./pages";

export {
  //////////////////////////////////////////////
  //////////        CONTAINERS        //////////
  //////////////////////////////////////////////
  GoogleSocialAuthButton,
  PrivateRoute,
  //////////////////////////////////////////////
  //////////         MODULES          //////////
  //////////////////////////////////////////////
  authenticationReducer,
  authenticateAccount,
  socialAuthenticateAccount,
  logoutAccount,
  registrationReducer,
  registerAccount,
  activationReducer,
  activateAccount,
  resendActivationEmail,
  passwordReducer,
  changePassword,
  sendResetPasswordEmail,
  //////////////////////////////////////////////
  //////////          PAGES           //////////
  //////////////////////////////////////////////
  AccountActivationPage,
  ChangePasswordPage,
  LoginPage,
  RegisterPage,
  ResendActivationPage,
  ResetPasswordPage,
};
